import React, { useEffect, useState } from 'react';
import { Users, Ticket, ShoppingCart } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
interface UrgencyBannerProps {
  spots: number;
  onSale: () => void;
  viewers: number;
}
export function UrgencyBanner({
  spots,
  onSale,
  viewers
}: UrgencyBannerProps) {
  const [isSticky, setIsSticky] = useState(false);
  const [recentSale, setRecentSale] = useState({
    show: false,
    text: ''
  });
  useEffect(() => {
    const handleScroll = () => {
      const purchaseSection = document.getElementById('purchase');
      if (purchaseSection) {
        const rect = purchaseSection.getBoundingClientRect();
        // Aparece sticky cuando la sección de compra está cerca de entrar o ya entró
        setIsSticky(rect.top <= 100);
      }
    };
    window.addEventListener('scroll', handleScroll);
    const sales = ['1 cupón vendido hace 5 mins', 'Nuevo acceso desde Mendoza hace 2 min', '1 cupón reservado hace instantes'];
    let saleTimeout: NodeJS.Timeout;
    const triggerSale = () => {
      const randomTime = Math.floor(Math.random() * (25000 - 15000 + 1)) + 15000;
      saleTimeout = setTimeout(() => {
        setRecentSale({
          show: true,
          text: sales[Math.floor(Math.random() * sales.length)]
        });
        onSale();
        setTimeout(() => {
          setRecentSale({
            show: false,
            text: ''
          });
        }, 4000);
        triggerSale();
      }, randomTime);
    };
    triggerSale();
    return () => {
      window.removeEventListener('scroll', handleScroll);
      clearTimeout(saleTimeout);
    };
  }, []);
  return <>
      {/* Floating Notification (When NOT sticky) */}
      <AnimatePresence data-id="element-282" data-mp="2ccrk8ey5ti0c">
        {!isSticky && recentSale.show && <motion.div initial={{
        opacity: 0,
        x: -50,
        y: 50
      }} animate={{
        opacity: 1,
        x: 0,
        y: 0
      }} exit={{
        opacity: 0,
        x: -50,
        scale: 0.8
      }} className="fixed bottom-6 left-6 z-[60] bg-white/70 backdrop-blur-md text-blue-950 px-3 py-2 rounded-xl shadow-[0_8px_32px_rgba(0,0,0,0.1)] border border-white/20 flex items-center gap-3 max-w-[280px]" data-id="element-283" data-mp="15099rcym36eg">
            <div className="w-8 h-8 bg-blue-600/10 rounded-full flex items-center justify-center text-blue-600 shrink-0 border border-blue-600/20" data-id="element-284" data-mp="sif2hqybt044">
              <ShoppingCart size={16} data-id="element-285" data-mp="xit68wsw9nwc" />
            </div>
            <div data-id="element-286" data-mp="joacf9r0nspn">
              <p className="text-[9px] font-black text-blue-600 uppercase tracking-widest leading-none mb-0.5" data-id="element-287" data-mp="jnqy030krmgd">
                Venta Reciente
              </p>
              <p className="font-bold text-xs leading-tight" data-id="element-288" data-mp="9rnrym2lr3o5">
                {recentSale.text}
              </p>
            </div>
          </motion.div>}
      </AnimatePresence>

      {/* Sticky Banner */}
      <motion.div initial={false} animate={{
      y: isSticky ? 0 : -100,
      opacity: isSticky ? 1 : 0
    }} className="py-2 fixed top-0 left-0 w-full z-50 shadow-[0_4px_30px_rgba(0,0,0,0.1)] border-b border-white/20 bg-white/60 backdrop-blur-md" data-id="element-289" data-mp="q7kon733ho5">
        <div className="max-container px-4 flex flex-wrap justify-center items-center text-xs font-black uppercase tracking-tighter gap-[10px]" data-id="element-290" data-mp="3ib94k1smxxns">
          <div className="flex text-[12px] font-[700] font-[Poppins,_sans-serif] gap-[8px] flex-row items-center justify-start text-blue-950" data-id="element-291" data-mp="3ra34a119j45k">
            <span className="relative flex h-2 w-2" data-id="element-292" data-mp="3mcumw2nxv45d">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-500 opacity-75" data-id="element-293" data-mp="51th8betnciu"></span>
              <span className="relative inline-flex rounded-full h-2 w-2 bg-green-500" data-id="element-294" data-mp="30fthct7bz1"></span>
            </span>
            <Users size={14} className="text-blue-600" data-id="element-295" data-mp="du55prqdkpw6" />
            {viewers} PERSONAS MIRANDO
          </div>
          <div className="flex items-center gap-2 font-[700] text-[12px] text-blue-950" data-id="element-296" data-mp="9vfv26wq1mg8">
            <span className="relative flex h-2 w-2" data-id="element-297" data-mp="ntdxcdxrpsfd">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-500 opacity-75" data-id="element-298" data-mp="iusx4eiin8qx"></span>
              <span className="relative inline-flex rounded-full h-2 w-2 bg-red-500" data-id="element-299" data-mp="12vcp96kka4ve"></span>
            </span>
            <Ticket size={14} className="text-blue-600" data-id="element-300" data-mp="16w6cryu3dhnr" />
            CUPOS DISPONIBLES: {spots}
          </div>

          {/* Integrated Notification (When sticky) */}
          <AnimatePresence data-id="element-301" data-mp="1gnsk3k3b6wl8">
            {isSticky && recentSale.show && <motion.div initial={{
            opacity: 0,
            scale: 0.9
          }} animate={{
            opacity: 1,
            scale: 1
          }} exit={{
            opacity: 0,
            scale: 0.9
          }} className="flex items-center gap-2 bg-white/40 backdrop-blur-sm text-blue-950 px-3 py-1.5 rounded-full border border-white/30 font-bold text-[11px] shadow-sm" data-id="element-302" data-mp="1gpdhdhh0ctms">
                <ShoppingCart size={14} className="text-blue-600" data-id="element-303" data-mp="xuoo3s2mc7ng" />
                {recentSale.text}
              </motion.div>}
          </AnimatePresence>
        </div>
      </motion.div>
    </>;
}